const parseQueryParams = ( queryParams ) => {
  if ( typeof queryParams === 'string' ) {
    return queryParams.replace( '?', '' ).split( '&' )
      .reduce( ( acc, parsedParam ) => {
        const [ key, value ] = parsedParam.split( '=' )
        return {
          ...acc,
          [ key ]: decodeURIComponent( value )
        }
      }, {} )
  }
  return null
}

export default parseQueryParams
